/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);if(window.GSUX_LANG&&window.GSUX_LANG[k]!=null)return window.GSUX_LANG[k];return k;};}
var TR=window.TR;
// components.js — tiny shared helpers (no dependencies)
window.GSUI = {
  fmt(n){ return (n==null?0:+n).toLocaleString(); },
  q(sel,root){ return (root||document).querySelector(sel); },
  qa(sel,root){ return Array.from((root||document).querySelectorAll(sel)); },
  gs(name,root){ return (root||document).querySelector('[data-gs="'+name+'"]'); },
  show(el,on){ if(el) el.classList.toggle('d-none', !on); },
  // dependency-free responsive SVG line chart
  lineChart(canvasEl, series, key){
    if(!canvasEl) return; const box=canvasEl.parentElement;
    const w=box.clientWidth||600, h=220, pad=24;
    const vals=series.map(p=>+p[key]||0); const max=Math.max(1,...vals);
    const step=series.length>1?(w-pad*2)/(series.length-1):0;
    const pts=vals.map((v,i)=>[pad+i*step, h-pad-(v/max)*(h-pad*2)]);
    const path=pts.map((p,i)=>(i?'L':'M')+p[0].toFixed(1)+' '+p[1].toFixed(1)).join(' ');
    const area=path+` L ${pad+(series.length-1)*step} ${h-pad} L ${pad} ${h-pad} Z`;
    const svg=`<svg viewBox="0 0 ${w} ${h}" width="100%" height="${h}" preserveAspectRatio="none">
      <path d="${area}" fill="var(--gs-primary-tint)"/>
      <path d="${path}" fill="none" stroke="var(--gs-primary)" stroke-width="2"/>
      ${pts.map(p=>`<circle cx="${p[0].toFixed(1)}" cy="${p[1].toFixed(1)}" r="2.5" fill="var(--gs-primary)"/>`).join('')}
    </svg>`;
    const wrap=document.createElement('div'); wrap.innerHTML=svg; canvasEl.replaceWith(wrap.firstElementChild);
  }
};

/* ─────────────────────────────────────────────────────────────────────────────
 * App-wide tooltips.
 *
 * Two problems this replaces:
 *   1. Bootstrap tooltips were initialised ONCE on DOMContentLoaded. Nearly every plugin renders its
 *      rows later, from an API response, so those tooltips were never initialised and silently did
 *      nothing. Initialisation is now lazy, on first hover, so it works whenever the element appeared.
 *   2. 46 plugin files use the native `title` attribute. Those work, but with a ~1s delay, no styling,
 *      and nothing in common with the tooltips on the public pages. They are now upgraded on first
 *      hover into the same bubble, with no per-plugin edits.
 *
 * The bubble is a single element on <body> at position:fixed. That placement is deliberate: an
 * absolutely-positioned CSS tooltip is clipped by any ancestor with overflow:hidden (every table cell
 * with text-overflow:ellipsis, every progress track, every chart panel) and can be painted over by a
 * later sibling. Both were real bugs on the public pages before this approach replaced them.
 *
 * GSUI.tip(text, x, y) / GSUI.tipHide() are exposed for canvas and SVG renderers that have no element
 * to hang an attribute on.
 * ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var tip = null, cur = null;

  function bubble() {
    if (tip) return tip;
    tip = document.createElement('div');
    tip.className = 'gs-tip';
    tip.setAttribute('role', 'tooltip');
    document.body.appendChild(tip);
    return tip;
  }
  function place(t, x, y, anchorH) {
    var pad = 8, w = t.offsetWidth, h = t.offsetHeight;
    var left = Math.max(pad, Math.min(x - w / 2, window.innerWidth - w - pad));
    var top = y - h - 10, cls = 'up';
    if (top < pad) { top = y + (anchorH || 0) + 10; cls = 'dn'; }   // flip below near the top edge
    t.style.left = Math.round(left) + 'px';
    t.style.top = Math.round(top) + 'px';
    t.classList.remove('up', 'dn');
    t.classList.add(cls, 'on');
  }
  function hide() { if (tip) tip.classList.remove('on'); cur = null; }

  /* Native `title` is claimed once, on first hover: the text moves to data-tip and the attribute is
     removed so the browser's own tooltip doesn't appear alongside ours. Accessible name is preserved
     via aria-label when the element doesn't already have one. */
  function claimTitle(el) {
    var t = el.getAttribute('title');
    if (t === null || t === '') return;
    el.setAttribute('data-tip', t);
    if (!el.getAttribute('aria-label') && !el.textContent.trim()) el.setAttribute('aria-label', t);
    el.removeAttribute('title');
  }
  /* Tooltips can be switched off for the account. Read once per call rather than caching, so the toggle
     takes effect immediately instead of on the next page load. */
  function tipsOn() {
    try { return localStorage.getItem('gs_tips_off') !== '1'; } catch (e) { return true; }
  }

  function target(node) {
    if (!tipsOn()) return null;
    if (!node || !node.closest) return null;
    var el = node.closest('[data-tip],[data-help],[title]');
    if (!el) return null;
    if (el.hasAttribute('data-no-tip')) return null;
    if (el.getAttribute('data-bs-toggle') === 'tooltip') return null;   // Bootstrap owns that one
    claimTitle(el);
    /* data-help predates data-tip and is used by the bar-list renderer; fold it in rather than run two
       tooltip systems with two bubbles on one page. */
    if (!el.getAttribute('data-tip') && el.getAttribute('data-help'))
      el.setAttribute('data-tip', el.getAttribute('data-help'));
    return el.getAttribute('data-tip') ? el : null;
  }
  function showFor(el) {
    var txt = el.getAttribute('data-tip'); if (!txt) return;
    var t = bubble(); t.textContent = txt; t.classList.add('on');
    var r = el.getBoundingClientRect();
    place(t, r.left + r.width / 2, r.top, r.height);
    cur = el;
  }

  GSUI.tip = function (text, x, y) {
    if (text == null || text === '') { hide(); return; }
    var t = bubble(); t.textContent = text; t.classList.add('on'); place(t, x, y, 0);
  };
  GSUI.tipHide = hide;

  document.addEventListener('mouseover', function (e) {
    /* Lazily initialise a Bootstrap tooltip that was rendered after page load. */
    var bs = e.target && e.target.closest ? e.target.closest('[data-bs-toggle="tooltip"]') : null;
    if (bs && window.bootstrap && bootstrap.Tooltip && !bootstrap.Tooltip.getInstance(bs)) {
      new bootstrap.Tooltip(bs).show();
      return;
    }
    var el = target(e.target);
    if (el && el !== cur) showFor(el);
  });
  document.addEventListener('mouseout', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-tip]') : null;
    if (el && el === cur) hide();
  });
  document.addEventListener('focusin', function (e) { var el = target(e.target); if (el) showFor(el); });
  document.addEventListener('focusout', hide);
  document.addEventListener('keydown', function (e) { if (e.key === TR('js.escape')) hide(); });
  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide, { passive: true });

  /* Anything already in the page at load still gets initialised eagerly, so a tooltip on static markup
     behaves the same as one on a rendered row. */
  /**
   * A sticky control on the right edge for turning tooltips off.
   *
   * Now that every explanatory label in the product carries one, someone who already knows the product
   * does not want a bubble following their cursor. This is deliberately NOT buried in Settings: the
   * moment you want it off is the moment one is in your way, and that moment should not require two
   * navigations.
   *
   * Collapsed to a small tab until hovered or focused, so the affordance is present without being another
   * thing on the screen.
   */
  function mountTipToggle() {
    if (document.querySelector('.gs-tiptoggle')) return;
    if (!document.body || document.body.classList.contains('gs-auth-body')) return;   // not on login
    var off = false;
    try { off = localStorage.getItem('gs_tips_off') === '1'; } catch (e) {}

    var box = document.createElement('div');
    box.className = 'gs-tiptoggle';
    box.innerHTML =
      '<button type="button" class="gs-tt-btn" aria-pressed="' + (off ? 'true' : 'false') + '">' +
        '<i class="bi bi-chat-square-text" aria-hidden="true"></i>' +
        '<span class="gs-tt-txt"></span>' +
      '</button>';
    document.body.appendChild(box);

    var btn = box.querySelector('.gs-tt-btn'), txt = box.querySelector('.gs-tt-txt');
    function paint() {
      box.classList.toggle('is-off', off);
      btn.setAttribute('aria-pressed', off ? 'true' : 'false');
      txt.textContent = off ? 'Tooltips off' : 'Tooltips on';
      /* Its own label must never be a tooltip: if tooltips are off, that would be unreadable. */
      btn.setAttribute('aria-label', off ? 'Turn tooltips on' : 'Turn tooltips off');
      btn.setAttribute('data-no-tip', '');
    }
    paint();
    btn.addEventListener('click', function () {
      off = !off;
      try { localStorage.setItem('gs_tips_off', off ? '1' : '0'); } catch (e) {}
      if (off) hide();                                   // dismiss anything already showing
      paint();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    mountTipToggle();
    if (window.bootstrap && bootstrap.Tooltip)
      GSUI.qa('[data-bs-toggle="tooltip"]').forEach(function (el) {
        if (!bootstrap.Tooltip.getInstance(el)) new bootstrap.Tooltip(el);
      });
  });
})();
/* ─────────────────────────────────────────────────────────────────────────────
 * Time formatting — one implementation, two account preferences.
 *
 * Both were being ignored, for different reasons:
 *   - the 12/24-hour choice was posted by the settings page but never saved, so nothing could honour it;
 *   - the chosen timezone never reached client-side rendering, so a browser in another zone quietly
 *     showed its own local time, and server-rendered pages outside a session showed the server's.
 *
 * Everything here reads GS.timeFormat and GS.tz, so a plugin calls one function rather than reaching
 * for toLocaleTimeString and inheriting whatever the browser felt like.
 *
 *   GSUI.time(v)      -> "14:07"            or "2:07 PM"
 *   GSUI.datetime(v)  -> "25 Jul 14:07"     or "25 Jul 2:07 PM"
 *   GSUI.hour(h)      -> "14:00"            or "2 PM"        (for hour-of-day axes)
 *   GSUI.is24()       -> boolean, for callers that need to branch (weather units, axis density)
 * ──────────────────────────────────────────────────────────────────────────── */
GSUI.is24 = function () { return !(window.GS && GS.timeFormat === '12'); };
GSUI.tz = function () { return (window.GS && GS.tz) || 'UTC'; };

/* Accepts a Date, an epoch (seconds or milliseconds), or a datetime string. Server timestamps are UTC
   and often lack a zone marker, which browsers read as LOCAL time — the classic silent hours-off bug —
   so a bare "YYYY-MM-DD HH:MM:SS" is treated as UTC explicitly. */
GSUI.toDate = function (v) {
  if (v instanceof Date) return v;
  if (typeof v === 'number') return new Date(v < 1e12 ? v * 1000 : v);
  var s = String(v == null ? '' : v).trim();
  if (!s) return null;
  if (/^\d+$/.test(s)) { var n = +s; return new Date(n < 1e12 ? n * 1000 : n); }
  if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(s)) s = s.replace(' ', 'T') + 'Z';
  var d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
};

GSUI.time = function (v) {
  var d = GSUI.toDate(v); if (!d) return '';
  try {
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit',
      hour12: !GSUI.is24(), timeZone: GSUI.tz() });
  } catch (e) {                                  // unknown zone: fall back rather than render nothing
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: !GSUI.is24() });
  }
};

GSUI.datetime = function (v) {
  var d = GSUI.toDate(v); if (!d) return '';
  var opt = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: !GSUI.is24() };
  try { opt.timeZone = GSUI.tz(); return d.toLocaleString([], opt); }
  catch (e) { delete opt.timeZone; return d.toLocaleString([], opt); }
};

/* Hour-of-day labels for axes: "14:00" or "2 PM". Takes 0-23, not a date. */
GSUI.hour = function (h) {
  h = Math.max(0, Math.min(23, parseInt(h, 10) || 0));
  if (GSUI.is24()) return (h < 10 ? '0' + h : h) + ':00';
  var ap = h < 12 ? 'AM' : 'PM', h12 = h % 12; if (h12 === 0) h12 = 12;
  return h12 + ' ' + ap;
};

/* Variants: 'success' | 'error' / 'danger' | 'warning' | anything else = info. Styled in components.css
   (.gs-toast + .gs-toast-<variant>). The same message already on screen is not stacked a second time —
   its timer restarts instead; a page that fires several refused saves at once (the read-only demo) used to
   pile up a column of identical lines. */
GSUI.toast = function (msg, variant) {
  const box = document.getElementById('gsToasts'); if (!box) return;
  const v = variant === 'danger' ? 'error' : (['success', 'error', 'warning'].indexOf(variant) >= 0 ? variant : 'info');
  const key = v + '|' + String(msg);
  let el = Array.prototype.find.call(box.children, function (c) { return c.__gsKey === key && !c.__gsGone; });
  if (!el) {
    el = document.createElement('div');
    el.className = 'gs-toast gs-toast-' + v + ' mb-2';
    el.setAttribute('role', v === 'error' || v === 'warning' ? 'alert' : 'status');
    el.textContent = msg; el.__gsKey = key;
    box.appendChild(el);
  }
  clearTimeout(el.__gsT1); clearTimeout(el.__gsT2); el.style.opacity = '';
  el.__gsT1 = setTimeout(() => {
    el.__gsGone = true; el.style.transition = 'opacity .4s'; el.style.opacity = '0';
    el.__gsT2 = setTimeout(() => el.remove(), 400);
  }, 3200);
};

/* Bootstrap tooltips live in <body> (container:"body"), so when the element that opened one is
   re-rendered, removed or hidden by a tab switch while the pointer is on it, Bootstrap never gets the
   mouseleave and the tooltip stays on screen — sometimes jumping to the top-left corner. One sweep for
   every page: any shown tooltip whose trigger is gone, hidden or no longer under the pointer is closed. */
(function () {
  let queued = false;
  function triggerOf(tip) {
    return tip.id ? document.querySelector('[aria-describedby~="' + tip.id + '"]') : null;
  }
  function sweep() {
    queued = false;
    document.querySelectorAll('body > .tooltip').forEach(function (tip) {
      const t = triggerOf(tip);
      const gone = !t || !t.isConnected || t.getClientRects().length === 0;
      const stale = !gone && !t.matches(':hover') && !t.matches(':focus-visible') && !t.matches(':focus');
      if (!gone && !stale) return;
      const inst = t && window.bootstrap && bootstrap.Tooltip && bootstrap.Tooltip.getInstance(t);
      if (inst && !gone) { try { inst.hide(); return; } catch (e) {} }
      tip.remove();
      if (t) t.removeAttribute('aria-describedby');
    });
  }
  function soon() { if (!queued) { queued = true; requestAnimationFrame(sweep); } }
  function start() {
    if (!document.body) return;
    new MutationObserver(function (list) {
      for (let i = 0; i < list.length; i++) if (list[i].removedNodes.length || list[i].type === 'attributes') { soon(); return; }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
    ['click', 'scroll', 'popstate', 'hashchange', 'visibilitychange'].forEach(function (ev) {
      (ev === 'popstate' || ev === 'hashchange' ? window : document).addEventListener(ev, soon, { capture: true, passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  GSUI.sweepTooltips = sweep;
})();

/* Persistent, updatable progress toast. Returns a handle: .update(msg, pct?), .done(msg, variant), .close().
   Used for long actions (e.g. PageSpeed refresh ~20-60s) so the user sees live progress, not a blind wait. */
GSUI.progressToast = function (msg) {
  const box = document.getElementById('gsToasts');
  if (!box) return { update(){}, done(){}, close(){} };
  const el = document.createElement('div');
  el.className = 'gs-toast gs-toast-progress mb-2';
  el.setAttribute('role', 'status');
  el.innerHTML = '<span class="gs-toast-spin" aria-hidden="true"></span>' +
                 '<span class="gs-toast-msg"></span>' +
                 '<span class="gs-toast-bar"><span class="gs-toast-bar-fill"></span></span>';
  el.querySelector('.gs-toast-msg').textContent = msg || '';
  box.appendChild(el);
  const msgEl = el.querySelector('.gs-toast-msg');
  const fill  = el.querySelector('.gs-toast-bar-fill');
  function remove(delay){ setTimeout(() => { el.style.transition = 'opacity .4s'; el.style.opacity = '0'; setTimeout(() => el.remove(), 400); }, delay || 0); }
  return {
    update(m, pct){ if (m != null) msgEl.textContent = m; if (pct != null && fill) fill.style.width = Math.max(0, Math.min(100, pct)) + '%'; },
    done(m, variant){
      el.querySelector('.gs-toast-spin').style.display = 'none';
      if (fill) fill.style.width = '100%';
      el.classList.remove('gs-toast-progress');
      el.classList.add(variant === 'error' ? 'gs-toast-error' : 'gs-toast-success');
      if (m != null) msgEl.textContent = m;
      const bar = el.querySelector('.gs-toast-bar'); if (bar) bar.style.display = 'none';
      remove(3000);
    },
    close(){ remove(0); }
  };
};


/* ===== v8 interactive components (ported) ===== */
Object.assign(GSUI, {
  countUp(el, to, dur){ if(!el) return; to=+to||0; dur=dur||800; var st=performance.now(), ez=t=>1-Math.pow(1-t,3);
    (function f(n){var p=Math.min(1,(n-st)/dur); el.textContent=GSUI.fmt(Math.round(to*ez(p))); if(p<1)requestAnimationFrame(f);})(st); },

  /* interactive area chart w/ magnetic crosshair. series=[{d,...}], keys=[{key,label,color(hex)}] */
  areaChart(mount, series, keys){
    if(!mount) return;
    if(!series||!series.length){ mount.innerHTML='<div class="gs-muted small p-3">'+TR('js.no_data_in_this_range_yet')+'</div>'; return; }
    var W=1000,H=280,P=8,n=series.length,max=1;
    keys.forEach(k=>series.forEach(p=>{max=Math.max(max,+p[k.key]||0);})); max*=1.12;
    var X=i=>P+(n>1?i/(n-1):0)*(W-P*2), Y=v=>H-P-(v/max)*(H-P*2);
    var defs='<defs>'+keys.map((k,i)=>'<linearGradient id="gsg'+i+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+k.color+'" stop-opacity=".20"/><stop offset="1" stop-color="'+k.color+'" stop-opacity="0"/></linearGradient>').join('')+'</defs>';
    var grid=''; for(var g=0;g<=4;g++){var yy=P+g*((H-P*2)/4); grid+='<line x1="'+P+'" x2="'+(W-P)+'" y1="'+yy+'" y2="'+yy+'" stroke="#EDEFF4" stroke-width="1"/>';}
    var paths=keys.map((k,i)=>{var pts=series.map((p,j)=>[X(j),Y(+p[k.key]||0)]);var ln=pts.map((c,j)=>(j?'L':'M')+c[0].toFixed(1)+' '+c[1].toFixed(1)).join(' ');
      return '<path d="'+ln+' L '+(W-P)+' '+(H-P)+' L '+P+' '+(H-P)+' Z" fill="url(#gsg'+i+')"/><path class="gsln" d="'+ln+'" fill="none" stroke="'+k.color+'" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>';}).join('');
    var cx='<line class="gscx" stroke="#AAB2BD" stroke-width="1" stroke-dasharray="4 4" opacity="0"/>'+keys.map((k,i)=>'<circle class="gscd gscd'+i+'" r="5" fill="#fff" stroke="'+k.color+'" stroke-width="2.6" opacity="0"/>').join('');
    mount.style.position='relative';
    mount.innerHTML='<svg class="gs-area" viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="none" style="width:100%;height:min(280px,44vw);touch-action:none">'+defs+grid+paths+cx+'<rect class="gshit" width="'+W+'" height="'+H+'" fill="transparent"/></svg><div class="gs-ctip"></div>';
    var svg=mount.querySelector('.gs-area'),tip=mount.querySelector('.gs-ctip'),cxl=svg.querySelector('.gscx'),hit=svg.querySelector('.gshit');
    svg.querySelectorAll('.gsln').forEach(p=>{var L=p.getTotalLength();p.style.strokeDasharray=L;p.style.strokeDashoffset=L;p.getBoundingClientRect();p.style.transition='stroke-dashoffset 1s cubic-bezier(.3,.7,.2,1)';p.style.strokeDashoffset=0;});
    function move(e){var r=svg.getBoundingClientRect(),cxp=(e.touches?e.touches[0].clientX:e.clientX);
      var px=(cxp-r.left)/r.width*W,i=Math.max(0,Math.min(n-1,Math.round((px-P)/(W-P*2)*(n-1)))),x=X(i);
      cxl.setAttribute('x1',x);cxl.setAttribute('x2',x);cxl.setAttribute('y1',P);cxl.setAttribute('y2',H-P);cxl.style.opacity=1;
      keys.forEach((k,ki)=>{var dot=svg.querySelector('.gscd'+ki),y=Y(+series[i][k.key]||0);dot.setAttribute('cx',x);dot.setAttribute('cy',y);dot.style.opacity=1;});
      tip.innerHTML='<div class="d">'+(series[i].d||series[i].label||'')+'</div>'+keys.map(k=>'<div class="r"><i style="background:'+k.color+'"></i>'+k.label+'<b>'+GSUI.fmt(+series[i][k.key]||0)+'</b></div>').join('');
      var hr=mount.getBoundingClientRect(),tx=x/W*r.width+(r.left-hr.left);tip.style.left=Math.max(60,Math.min(hr.width-60,tx))+'px';tip.style.top=(r.top-hr.top)+'px';tip.style.opacity=1;}
    function leave(){cxl.style.opacity=0;svg.querySelectorAll('.gscd').forEach(d=>d.style.opacity=0);tip.style.opacity=0;}
    hit.addEventListener('mousemove',move);hit.addEventListener('mouseleave',leave);hit.addEventListener('touchmove',e=>{e.preventDefault();move(e);});
  },

  /* bidirectional donut. data=[{label,value,color(hex)}] */
  donut(mount, data, unit){
    if(!mount) return; unit=unit||'';
    if(!data||!data.length){ mount.innerHTML='<div class="gs-muted small">'+TR('js.no_data_yet')+'</div>'; return; }
    var total=data.reduce((a,b)=>a+(+b.value||0),0)||1,R=68,C=2*Math.PI*R,off=0;
    var segs=data.map((d,i)=>{var fr=(+d.value||0)/total,s='<circle class="seg" data-i="'+i+'" r="'+R+'" cx="84" cy="84" stroke="'+d.color+'" stroke-dasharray="'+(fr*C)+' '+C+'" stroke-dashoffset="'+(-off)+'"/>';off+=fr*C;return s;}).join('');
    mount.innerHTML='<div class="gs-donutwrap"><div class="gs-donut"><svg viewBox="0 0 168 168">'+segs+'</svg><div class="ctr"><b>'+GSUI.fmt(total)+'</b><span>total</span></div></div><div class="gs-dleg">'+data.map((d,i)=>'<div class="k" data-i="'+i+'"><i style="background:'+d.color+'"></i><span class="nm">'+d.label+'</span><b>'+GSUI.fmt(d.value)+unit+'</b></div>').join('')+'</div></div>';
    var seg=mount.querySelectorAll('.seg'),leg=mount.querySelectorAll('.gs-dleg .k');
    function focus(i){seg.forEach(s=>{var on=+s.dataset.i===i;s.style.opacity=on?1:.35;s.style.strokeWidth=on?'23':'16';});leg.forEach(l=>{var on=+l.dataset.i===i;l.style.opacity=on?1:.4;l.style.fontWeight=on?'800':'600';l.style.transform=on?'scale(1.05)':'none';});}
    function clr(){seg.forEach(s=>{s.style.opacity=1;s.style.strokeWidth='16';});leg.forEach(l=>{l.style.opacity=1;l.style.fontWeight='600';l.style.transform='none';});}
    seg.forEach(s=>{s.addEventListener('mouseenter',()=>focus(+s.dataset.i));s.addEventListener('mouseleave',clr);});
    leg.forEach(l=>{l.addEventListener('mouseenter',()=>focus(+l.dataset.i));l.addEventListener('mouseleave',clr);});
  },

  /* animated bar list. rows=[{label,value,icon?}] */
  barList(mount, rows){
    if(!mount) return; var max=Math.max(1,...rows.map(r=>+r.value||0));
    mount.innerHTML='<div class="gs-bars">'+rows.map(r=>{var pct=Math.round((+r.value||0)/max*100);
      return '<div class="gs-bar" data-help="'+GSUI.fmt(r.value)+' · '+pct+'% of total"><div class="nm">'+(r.icon?'<span class="fav">'+r.icon+'</span>':'')+'<span>'+(r.label||'—')+'</span></div><div class="v">'+GSUI.fmt(r.value)+'</div><div class="track"><i data-w="'+pct+'"></i></div></div>';}).join('')+'</div>';
    requestAnimationFrame(()=>mount.querySelectorAll('.track i').forEach(i=>i.style.width=i.dataset.w+'%'));
    GSUI.wireHelp(mount);
  },

  /* hover-help tooltips (data-help) */
  tipEl:null,
  /* Kept so existing callers keep working. The tooltip engine is delegated on the document, so
     [data-help] elements need no wiring at all — including ones rendered after this ran, which the old
     per-element binding never covered. */
  wireHelp(){ /* no-op: handled by delegation */ }
});

/* KPI sparkline path (returns inner SVG for a 120x32 viewBox mount) */
GSUI.sparkPath = function(data){
  if(!data||!data.length) return '';
  var W=120,H=32,mn=Math.min.apply(null,data),mx=Math.max.apply(null,data),rng=(mx-mn)||1;
  var pts=data.map(function(v,i){return [(data.length>1?i/(data.length-1):0)*W, H-3-((v-mn)/rng)*(H-6)];});
  var line=pts.map(function(c,i){return (i?'L':'M')+c[0].toFixed(1)+' '+c[1].toFixed(1);}).join(' ');
  var up=data[data.length-1]>=data[0], col=up?'#1FA463':'#E0533D';
  return '<path d="'+line+' L '+W+' '+H+' L 0 '+H+' Z" fill="'+col+'" opacity=".10"/>'+
         '<path d="'+line+'" fill="none" stroke="'+col+'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>';
};

/* GSMore — shared client-side pager. For lists that arrive already aggregated to a top-N (most
   GhostStat plugin lists build + sort in PHP, then slice), this renders the first `pageSize` rows
   and reveals more on demand — a "Load more" button plus optional autoload when it scrolls into
   view. No re-fetch, no SQL OFFSET: instant paging over the array already in hand.
   Usage: GSMore.mount({ container, items, render(item,i)->html, pageSize?, listClass?, autoload?, emptyHtml? }) */
window.GSMore = {
  mount: function (opt) {
    opt = opt || {};
    var host = opt.container; if (!host || typeof opt.render !== 'function') return null;
    var items = opt.items || [], size = Math.max(1, opt.pageSize || 20),
        autoload = opt.autoload !== false, shown = 0, io = null;
    // Table mode: rows are <tr> appended straight into the <tbody>, and the "Load more" control is a
    // full-width footer <tr>. A <div> can't live inside a <tbody>, which is why table-based lists
    // couldn't use the div pager before. Auto-detected when the container is a TBODY.
    var isTable = opt.table === true || (host.tagName === 'TBODY'), cs = opt.colspan || 99;
    host.innerHTML = '';
    if (!items.length) {
      host.innerHTML = isTable
        ? '<tr class="gs-more-empty-row"><td colspan="' + cs + '" class="gs-more-empty">' + (opt.emptyText || 'Nothing to show.') + '</td></tr>'
        : (opt.emptyHtml || '<div class="gs-more-empty">'+TR('js.nothing_to_show')+'</div>');
      return { total: 0 };
    }
    var listEl, footEl, footRow = null;
    if (!isTable) {
      listEl = document.createElement('div'); listEl.className = opt.listClass || 'gs-more-list'; host.appendChild(listEl);
      footEl = document.createElement('div'); footEl.className = 'gs-more-foot'; host.appendChild(footEl);
    }
    function page() {
      var next = items.slice(shown, shown + size),
          html = next.map(function (it, i) { return opt.render(it, shown + i); }).join('');
      if (isTable) { if (footRow) { footRow.remove(); footRow = null; } host.insertAdjacentHTML('beforeend', html); }
      else listEl.insertAdjacentHTML('beforeend', html);
      shown += next.length;
      // Rows revealed later still need whatever per-row work the caller does (lazy metric
      // fetches, observers). onPage receives only the items just added.
      if (typeof opt.onPage === 'function') { try { opt.onPage(next, host); } catch (e) {} }
      foot();
    }
    function wireBtn(b) {
      b.addEventListener('click', page);
      if (autoload && 'IntersectionObserver' in window) {
        if (io) io.disconnect();
        io = new IntersectionObserver(function (e) { if (e[0] && e[0].isIntersecting) page(); }, { rootMargin: '160px' });
        io.observe(b);
      }
    }
    function foot() {
      var rem = items.length - shown;
      if (isTable) {
        if (footRow) { footRow.remove(); footRow = null; }
        if (rem <= 0) { if (items.length > size) host.insertAdjacentHTML('beforeend', '<tr class="gs-more-foot-row"><td colspan="' + cs + '"><div class="gs-more-done">All ' + items.length + ' shown</div></td></tr>'); if (io) { io.disconnect(); io = null; } return; }
        host.insertAdjacentHTML('beforeend', '<tr class="gs-more-foot-row"><td colspan="' + cs + '"><button type="button" class="gs-more-btn">Load ' + Math.min(size, rem) + ' more <span class="gs-more-rem">' + rem + ' left</span></button></td></tr>');
        footRow = host.querySelector('.gs-more-foot-row'); wireBtn(footRow.querySelector('.gs-more-btn')); return;
      }
      if (rem <= 0) { footEl.innerHTML = items.length > size ? '<div class="gs-more-done">All ' + items.length + ' shown</div>' : ''; if (io) { io.disconnect(); io = null; } return; }
      footEl.innerHTML = '<button type="button" class="gs-more-btn">Load ' + Math.min(size, rem) + ' more <span class="gs-more-rem">' + rem + ' left</span></button>';
      wireBtn(footEl.querySelector('.gs-more-btn'));
    }
    // startAt lets a caller restore how far the list was expanded — needed by any list that
    // re-renders on a timer, where remounting at page 1 would yank rows out from under the reader.
    var want = Math.min(items.length, Math.max(size, parseInt(opt.startAt, 10) || 0));
    do { page(); } while (shown < want);
    return { total: items.length, shown: shown };
  }
};
